<template>
  <component :is="way" v-if="loaded" />
</template>

<script>
import { STORE_PREFIX } from '../constants.js';
import store from '../stores.js';
import basic from './default';
const innerjti = () => import(/* webpackChunkName: "innerjti" */ '@/process/innerjti/components/interview/Scene');

export default {
  name: 'InterviewTest',

  components: {
    default: basic,
    innerjti
  },

  mixins: [store],

  props: ['process', 'token'],

  data() {
    return {
      loaded: false
    };
  },

  computed: {
    way() {
      const process = this.$store.getters['tests_interview/process'];
      if (process === 'innerjti') {
        return process;
      } else {
        return 'default';
      }
    }
  },

  created() {
    this.$store.commit(STORE_PREFIX + 'test/set_token', this.token);
    this.$store.commit(STORE_PREFIX + 'test/questions/set_token', this.token);
    this.$store.commit(STORE_PREFIX + 'test/question/set_token', this.token);

    this.$store.dispatch(STORE_PREFIX + 'interview/load', this.token).then(r => {
      if (r.data.data[0].vacancy.is_disable_record_videointerview || !r.data.data[0].vacancy.is_active) {
        this.$router.push({ name: 'interview', params: { token: this.token } });
        return false;
      }
      if (r.data.data[0].stage.id !== 'test') {
        this.$router.push({ name: 'interview', params: { token: this.token } });
      } else {
        this.$store.dispatch(STORE_PREFIX + 'test/load').then(() => {
          this.loaded = true;
        });
      }
    });
  }
};
</script>
